import React from 'react'
import PropTypes from 'prop-types'
import 'plyr/dist/plyr.css'
import Plyr from './Plyr'
import { getImageUrlPrefix, getThumbUrlPrefix } from '../helpers'
import withWindowSize from '../hoc/withWindowSize';

const srcPrefixFromWidth = (isMobile) => {
  if (isMobile) {
    return getThumbUrlPrefix('work-posters')
  }
  return getImageUrlPrefix('work-posters')
}

const getHeight = (width, videoRatio) => width * videoRatio * 0.01

const Project = ({
  director,
  height,
  isActive,
  isMobile,
  isPlaying,
  onClick,
  onTogglePlay,
  poster,
  slug,
  title,
  videoRatio,
  videoUrl,
  width,
}) => (
  <div
    className={`project ${slug}`}
    style={width >= 768 ? { width } : {}}
  >
    <div
      className="vimeo-wrapper"
      style={{ height: height || getHeight(width, videoRatio) }}
    >
      <Plyr
        type="video"
        url={videoUrl}
        className={`player__${slug}`}
        poster={`${srcPrefixFromWidth(isMobile)}${poster}`}
        iconUrl="../images/sprites.svg"
        onPlay={() => { onTogglePlay(true) }}
        onPause={() => { onTogglePlay(false, isActive) }}
        onEnd={() => { onTogglePlay(false) }}
        isPlaying={isActive && isPlaying}
        preload="none"
      />
      {/* eslint-disable */}
      <img
        onClick={onClick}
        className="solo-poster"
        src={`${srcPrefixFromWidth(isMobile)}${poster}`}
        alt=""
      />
      {/* eslint-enable */}
    </div>
    <div className="info">
      <h2>{title}</h2>
      <p>Director: {director}</p>
    </div>
  </div>
)

Project.propTypes = {
  isActive: PropTypes.bool,
  isPlaying: PropTypes.bool,
  onClick: PropTypes.func,
  onTogglePlay: PropTypes.func,
  poster: PropTypes.string.isRequired,
  director: PropTypes.string.isRequired,
  height: PropTypes.number,
  slug: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  videoRatio: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
}

Project.defaultProps = {
  isActive: false,
  isPlaying: false,
  onClick: () => {},
  onTogglePlay: () => {},
  height: 0,
}

export default withWindowSize(Project)



// WEBPACK FOOTER //
// ./src/components/Project.js